import axiosInstance from "./axiosConfig";

const settingService = {
  // Get settings
  getSettings: async () => {
    try {
      const response = await axiosInstance.get("/settings");
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update COD setting
  updateCodSetting: async (codEnabled) => {
    try {
      const response = await axiosInstance.patch("/settings/cod", {
        codEnabled,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Size operations
  addSize: async (sizeData) => {
    try {
      const response = await axiosInstance.post("/settings/sizes", sizeData);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateSize: async (id, sizeData) => {
    try {
      const response = await axiosInstance.put(
        `/settings/sizes/${id}`,
        sizeData
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  deleteSize: async (id) => {
    try {
      const response = await axiosInstance.delete(`/settings/sizes/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Color operations
  addColor: async (colorData) => {
    try {
      const response = await axiosInstance.post("/settings/colors", colorData);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateColor: async (id, colorData) => {
    try {
      const response = await axiosInstance.put(
        `/settings/colors/${id}`,
        colorData
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  deleteColor: async (id) => {
    try {
      const response = await axiosInstance.delete(`/settings/colors/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Delivery Fee operations
  addDeliveryFee: async (deliveryFeeData) => {
    try {
      const response = await axiosInstance.post(
        "/settings/delivery-fees",
        deliveryFeeData
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateDeliveryFee: async (id, deliveryFeeData) => {
    try {
      const response = await axiosInstance.put(
        `/settings/delivery-fees/${id}`,
        deliveryFeeData
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  deleteDeliveryFee: async (id) => {
    try {
      const response = await axiosInstance.delete(
        `/settings/delivery-fees/${id}`
      );
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export default settingService;
